import React, { useEffect, useMemo, useState } from 'react';
import { translate } from '../../Services/translation';
import clsx from 'clsx';
import ResponsiveImage from '../ResponsiveImage';
const MAX_DESCRIPTION_LENGTH = 240;

const ListingHeader = ({ title, description, image }) => {
  const [showMore, setShowMore] = useState(true);
  const descriptionLength = useMemo(() => description?.length, [description]);

  useEffect(() => {
    setShowMore(descriptionLength >= MAX_DESCRIPTION_LENGTH);
  }, [descriptionLength]);

  return (
    <div className="listing-header__wrapper">
      <div className="listing-header">
        <div className="listing-header__left">
          <div className="listing-header__content">
            {title && <h1 className="listing-header__title">{title}</h1>}
            {description && (
              <div
                className={clsx(
                  'listing-header__description',
                  showMore ? 'listing-header__description--hidden' : ''
                )}
              >
                {description}
              </div>
            )}
          </div>
          {descriptionLength >= MAX_DESCRIPTION_LENGTH && (
            <button
              className="listing-header__button"
              onClick={() => setShowMore(!showMore)}
            >
              {!showMore
                ? translate('general.show-less')
                : translate('general.show-more')}
            </button>
          )}
        </div>
        {image && (
          <div className="listing-header__right">
            <div className="listing-header__image-container">
              <ResponsiveImage {...image} className="listing-header__image" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListingHeader;
